import { getGranularity, getRequestPeriods, getSelectedSiteIds, getTimeSeriesData } from './shared';

export const buildMobileRequest = (definition, filters, scope) => {
  if (filters.campaignsReady === false) return null;
  const siteIds = getSelectedSiteIds(filters.selectedSites);
  if (!Object.values(scope || {}).some(Boolean) || !filters.startDate || !filters.endDate || !siteIds.length) return null;
  if (definition.resultKind === 'funnel' && (siteIds.length < 2 || siteIds.length > 5)) return null;
  // Preserve the backend campaign value; never use decorated labels or selector-generated IDs.
  const campaigns = filters.selectedCampaigns ?? filters.selectedAdvertisers;
  const campaignValues = (campaigns || []).map(item => typeof item === 'string' ? item :
    item.campaignId || (!item.cmsId ? item.id : null));
  const campaignIds = [...new Set(campaignValues.filter(Boolean))];
  // Never broaden an explicit empty selection or send a UI-generated CMS option ID.
  if (Array.isArray(filters.selectedCampaigns) && !filters.selectedCampaigns.length) return null;
  if (campaignValues.some(value => !value)) return null;
  const selection = { siteIds, ...(campaignIds.length ? { campaignIds } : {}) };
  const viewFilters = {};
  if (filters.filterByWeekday?.length) viewFilters.weekdays = filters.filterByWeekday;
  if (filters.filterByTime?.start && filters.filterByTime?.end) viewFilters.timeOfDay = filters.filterByTime;
  if (definition.segmentFilter && filters.selectedSegments?.length) {
    viewFilters.segmentIds = filters.selectedSegments.map(item => typeof item === 'string' ? item : item.id);
  }
  const period = getRequestPeriods(filters, filters.timezone).current;
  if (definition.resultKind === 'timeSeries') period.granularity = definition.granularity || getGranularity(filters.interval);
  return { scope, period, selection, ...(Object.keys(viewFilters).length ? { filters: viewFilters } : {}) };
};

export const adaptMobileResponse = (definition, response, filters) => {
  if (definition.resultKind === 'scalar') return { data: [{ label: definition.title,
    value: Number(response?.scalar?.value ?? response?.scalar?.decimalValue ?? 0) }] };
  if (definition.resultKind === 'timeSeries') {
    const result = getTimeSeriesData(response, definition.granularity || getGranularity(filters.interval), filters.timezone || 'UTC');
    return { data: result.data, plotOptions: { ...definition.plotOptions, categories: result.categories } };
  }
  const points = response?.categorySeries?.points || [];
  if (definition.resultKind === 'heatmap') return { data: points.map(point => ({
    label: `${point.x};${Number(point.y) + 1}`, value: Number(point.value ?? point.decimalValue ?? 0)
  })) };
  const data = points.map(point => ({ label: point.label || point.key,
    value: Number(point.value ?? point.decimalValue ?? 0) }));
  return { data: definition.display === 'bar' ? [{ label: definition.title, value: data }] : data };
};
